import { render, staticRenderFns } from "./MyInventory.vue?vue&type=template&id=62637eea&scoped=true"
import script from "./MyInventory.vue?vue&type=script&lang=js"
export * from "./MyInventory.vue?vue&type=script&lang=js"
import style0 from "./MyInventory.vue?vue&type=style&index=0&id=62637eea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62637eea",
  null
  
)

export default component.exports